import { FormattedCopyMarkdown } from "@/components/form-copy/FormattedCopyMarkdown";

import type { QuestionRendererProps } from "../types";

export const RichTextQuestion = ({ question }: QuestionRendererProps<null>) => {
  if (question.type !== "rich_text") {
    return null;
  }

  return (
    <FormattedCopyMarkdown
      content={question.markdown}
      variant="body"
      className="text-sm"
    />
  );
};
